import { JSX } from "@emotion/react/jsx-runtime";
import { Box, Paper, Stack, StackOwnProps, styled, Typography } from "@mui/material";
import { DynamicStackContent } from "../DynamicContentComponent";
import { ResponsiveStyleValue } from "@mui/system";

const PaperItem = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const BoxItem = styled(Box)(({ theme }) => ({
  //width: "100%",
  //height: 120,
  padding: theme.spacing(2),
  ...theme.typography.body2,
  textAlign: 'left',
}));

export const DynamicStack = ({ direction, stackItems, sxProps, containerType, key, childElements }: DynamicStackContent): JSX.Element => {
  let sxPropsObject = {};
  if (sxProps) {
    sxPropsObject = sxProps;
  }
  
  // Convert type direction
  const directionConverted = direction as ResponsiveStyleValue<'row' | 'row-reverse' | 'column' | 'column-reverse'>;

  return (
    <Box> 
      <Stack direction={directionConverted} spacing={2} sx={sxPropsObject}>
        {(!containerType || containerType === "Paper") && stackItems.map((stackItem, itemIndex) => {
          return <PaperItem key={`${key}-item-${itemIndex}`}>{stackItem}</PaperItem>
        })}
        {(containerType === "Box") && stackItems.map((stackItem, itemIndex) => {
          return <BoxItem key={`${key}-item-${itemIndex}`}>{stackItem}</BoxItem>
        })}
        {childElements || ''}
      </Stack>
    </Box>
  )    
}